import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'doubleDecimal'
})
@Injectable({
    providedIn: 'root'
})
export class DoubleDecimalPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) {

    }

    transform(value: any, ...args: any[]): any {
        return this.decimalPipe.transform(value, '1.2-2');
    }

}
